import React from 'react';
import { Button, Form } from 'react-bootstrap';
import './Contact.css'
const Contact = () => {
    return (
        <div>
            <Form className="w-50 m-5">
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="name@example.com" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Textarea</Form.Label>
                    <Form.Control as="textarea" rows={3} />
                </Form.Group>
                <Button id="btn" type="submit">
                    Submit
                </Button>
            </Form>
        </div>
    );
};

export default Contact;